import React, { Component } from 'react';
import { t } from '../i18n';
import LcIcon from '../widget/lc-icon.js';

/**
 * 游戏消息组件 - 通过postMessage在新窗口打开游戏
 */
export default class GameMessage extends Component {
    handleGameClick = () => {
        const { gameUrl, onGameClick } = this.props;
        if (onGameClick) {
            onGameClick(gameUrl);
        }
    }

    render() {
        const { message, gameType, theme } = this.props;

        const styles = {
            container: {
                backgroundColor: 'var(--lc-surface, #ffffff)',
                border: 'var(--lc-hairline)',
                borderRadius: 'var(--lc-radius-md)',
                boxShadow: 'var(--lc-shadow-1)',
                padding: 'var(--lc-space-3)',
                margin: 'var(--lc-space-2) 0',
                maxWidth: '320px',
            },
            message: {
                marginBottom: message ? '12px' : '0',
                color: 'var(--lc-text, #1e293b)',
                fontSize: '14px',
                lineHeight: '1.5',
            },
            button: {
                padding: 'var(--lc-space-2) var(--lc-space-3)',
                background: 'var(--lc-main)',
                color: 'var(--lc-bubble-user-text, #ffffff)',
                border: 'none',
                borderRadius: 'var(--lc-radius-sm)',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 'var(--lc-space-2)',
                width: '100%',
                transition: 'filter var(--lc-dur-base) var(--lc-ease-out)',
                boxShadow: 'var(--lc-shadow-1)'
            },
            gameInfo: {
                marginTop: 'var(--lc-space-2)',
                fontSize: '12px',
                color: 'var(--lc-text-3, #999)',
                textAlign: 'center'
            }
        };

        // 手柄图标取代原来的 🐦：emoji 的颜色由系统定，主色一换就露馅；
        // 而且那只鸟把卡片钉死在 Flappy Bird 这一款上，多一款游戏就得多一只动物。
        const gameTitle = gameType === 'flappy_bird' ? 'Flappy Bird' : t('game.start');

        return (
            <div style={styles.container}>
                {message && (
                    <div style={styles.message}>{message}</div>
                )}

                <button 
                    style={styles.button}
                    onClick={this.handleGameClick}
                    onMouseOver={(e) => e.target.style.filter = 'brightness(0.92)'}
                    onMouseOut={(e) => e.target.style.filter = 'none'}
                >
                    <LcIcon name="game" size={16} />
                    <span>{gameTitle}</span>
                </button>

                {gameType && (
                    <div style={styles.gameInfo}>
                        {t('game.tap_hint')}
                    </div>
                )}
            </div>
        );
    }
}
